import constants from './BaseConstants';
export default {
  LOGIN_URL: constants.BASE_URL + 'admin/merchants/login',
  LOGIN_USER: 'LOGIN_USER',
  LOGOUT_USER: 'LOGOUT_USER'
}



/** WEBPACK FOOTER **
 ** ./src/constants/LoginConstants.js
 **/